export default ({ service, request, serviceForMock, requestForMock, mock, faker, tools }) => ({
  listOrdinaryApi (data = {}) {
    return request({
      url: '/digitalCenter/masterSample/listOrdinary',
      method: 'post',
      data
    })
  },
  listSeniorApi (data = {}) {
    return request({
      url: '/digitalCenter/masterSample/listSenior',
      method: 'post',
      data
    })
  },
  digitalSampleInfoDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/masterSample/detail',
      method: 'post',
      data
    })
  },
  sampleInfoMaterialListApi(data = {}) {
    return request({
      url: '/master/sample/info/material/list',
      method: 'post',
      data
    })
  },

})